
import { i18nText } from '@/locales';

//@ts-ignore
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Photo from "@/UI/components/common/Photo.vue";
import Badge from "@/UI/components/common/Badge.vue";
import { workerTabs } from "@/utils/tabs";
import WorkerDocs from "@/UI/components/workerDetail/workerDetailTabs/WorkerDocs.vue";
import WorkerNotes from "@/UI/components/workerDetail/workerDetailTabs/WorkerNotes.vue";
import WorkerServices from "@/UI/components/workerDetail/workerDetailTabs/WorkerServices.vue";
import WorkerSchedule from "@/UI/components/workerDetail/workerDetailTabs/WorkerSchedule.vue";
import WorkerTasks from "@/UI/components/workerDetail/workerDetailTabs/WorkerTasks.vue";
import { IWorkersListItem } from "@/entity/workers/workers.types";
import { IBadge } from "@/entity/common/badge.types";
import { IStatus } from "@/entity/status/status.types";
import { IPosition } from "@/entity/position/position.types";
import { ISalaryScheme } from "@/entity/salaryScheme/salaryScheme.types";
import StaffUpdateForm from "@/form/staff/StaffUpdate";

@Component({
  components: { WorkerTasks, WorkerSchedule, WorkerServices, WorkerNotes, WorkerDocs, Badge, Photo }
})
export default class WorkerDetail extends Vue {
  @Prop({ default: 0 }) readonly initialTab!: number;
  @Prop() form!: StaffUpdateForm;
  @Prop() readonly worker!: IWorkersListItem | null;
  @Prop() readonly statusName!: IStatus[];
  @Prop() readonly position!: IPosition[];
  @Prop() readonly scheme!: ISalaryScheme[];


  statusColor = '';
  tabs = workerTabs
  badge: IBadge[] = [];
  salary = ''

  @Watch('worker', { immediate: true })
  onWorkerChanged(): void {

    if (this.worker?.salary_schema_id) {
      let scheme = this.scheme.find(el => el.id === this.worker?.salary_schema_id);
      if (scheme) {
        this.salary = scheme.name;
      }
    }

    this.badge = [
      { id: 0, title: i18nText("Активность"), text: this.worker!.status.name },
      { id: 1, title: i18nText("Должность"), text: this.worker!.position.name },

      { id: 3, title: i18nText("Схема зп"), text: this.salary },
      { id: 4, title: i18nText("Дата рождения"), text: this.worker!.birth_date },
      { id: 5, title: i18nText("Телефон"), text: this.worker!.phone },
      { id: 6, title: i18nText("Дата приема на работу"), text: this.worker!.employment_date },
      { id: 7, title: i18nText("Описание"), text: this.worker!.description }
    ]

    if (this.worker !== null) {
      this.statusColor = this.worker!.status.color!;
      if (this.worker.category) {
        if (this.badge.length === 7) {
          this.badge.splice(2, 0, { id: 2, title: i18nText("Категория"), text: this.worker!.category.name });
        }
      } else if (!this.worker.category) {
        if (this.badge.length === 8) {
          this.badge.splice(2, 1)
        }
      }
    }
  }

  created() {
  }

}
